import { Fragment } from 'react';
import { usePagination, DOTS } from './usePagination';
import {
  NextLabel,
  PaginationContainer,
  PaginationItem,
  PrevLabel,
} from './Paginate.styled';
import { MdOutlineNavigateNext, MdOutlineNavigateBefore } from 'react-icons/md';

interface PaginateProps {
  onPageChange: (page: number | string) => void;
  totalPageCount: number;
  siblingCount?: number;
  currentPage: number;
  pageSize: number;
  nextLabel?: string;
  previousLabel?: string;
}

export const Paginate = (props: PaginateProps) => {
  const {
    onPageChange,
    totalPageCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    nextLabel,
    previousLabel,
  } = props;

  const paginationRange = usePagination(
    totalPageCount,
    pageSize,
    siblingCount,
    currentPage
  );

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    if (currentPage === lastPage) return;
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage === 1) return;
    onPageChange(currentPage - 1);
  };

  const lastPage = paginationRange[paginationRange.length - 1];
  return (
    <PaginationContainer>
      <PaginationItem disabled={currentPage === 1} onClick={onPrevious}>
        <PrevLabel>
          {previousLabel || <MdOutlineNavigateBefore size={16} />}
        </PrevLabel>
      </PaginationItem>
      {paginationRange.map((pageNumber, idx) => {
        if (pageNumber === DOTS) {
          return (
            <PaginationItem dots key={idx}>
              ...
            </PaginationItem>
          );
        }

        return (
          <PaginationItem
            key={idx}
            selected={pageNumber === currentPage}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </PaginationItem>
        );
      })}
      <PaginationItem disabled={currentPage === lastPage} onClick={onNext}>
        <NextLabel>
          {nextLabel || <MdOutlineNavigateNext size={16} />}
        </NextLabel>
      </PaginationItem>
    </PaginationContainer>
  );
};
